<template>
  <modal
    :name="id"
    :adaptive="true"
    :height="315"
    :clickToClose="false"
  >
    <div class="modal-content">
      <!-- <img
        src="@/assets/icons/close.svg"
        alt="close"
        class="close-button"
        @click="$modal.hide(id)"
      > -->

      <h1 class="fn-title-1 main-title">
        Підтвердження заявки
      </h1>

      <p class="sign-modal-subtitle">
        {{message}}
      </p>

      <DefaultInput
        key="code"
        v-model="code"
        label="Код з СМС"
        class="input"
        v-validate="'required'"
      />

      <div class="buttons">
        <button
          class="main-btn second-color large-btn next-btn button"
          @click="submit"
        >
          Продовжити
        </button>

        <button
          class="second-btn second-color large-btn next-btn button"
          :disabled="timer !== 0"
          @click="retry"
        >
          Повторно запросити {{ timer ? `(${timer} сек)` : '' }}
        </button>
      </div>

    </div>
  </modal>
</template>

<script>
import DefaultInput from '@/components/Ui-new/DefaultInput.vue'

const OTP_TIMEOUT = 60

export default {
  name: 'DocumentsOtpModal',
  components: {
    DefaultInput
  },
  methods: {
    hide () {
      this.$modal.hide(this.$props.id)
    },
    submit () {
      this.$validator
        .validateAll()
        .then((result) => {
          if (result) {
            this.$emit('submit', {
              code: this.code
            })

            this.timer = 0
          }
        })
    },
    retry () {
      if (this.timer <= 0) {
        this.$emit('retry')
        this.startTimer()
      }
    },
    startTimer () {
      this.timer = OTP_TIMEOUT
      if (this.interval) {
        clearInterval(this.interval)
      }

      this.interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1
        } else {
          clearInterval(this.interval)
        }
      }, 1000)
    }
  },
  data () {
    return {
      code: null,
      timer: OTP_TIMEOUT
    }
  },
  async created () {
    this.startTimer()
  },
  props: ['id', 'message', 'timeout']
}
</script>

<style lang="less" scoped>
.modal-content {
  padding: 40px;
}
.input {
  &:first-of-type {
    margin-top: 20px;
  }
  margin-bottom: 20px;
}
.buttons {
  display: flex;
}
.button {
  margin-right: 8px;
}
.close-button {
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;
}
</style>
